import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import PropTypes from 'prop-types';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { Sharebelt } from '../component/Sharebelt';
import ShareBeltShareButton from '../component/modules/ShareBeltShare/ShareBeltShareButton';
import ShareBeltPrint from '../component/modules/ShareBeltPrint/ShareBeltPrint';

export const PIPSharebelt = ({ horizontal, itemId, email }) => {
  const theme = useTheme(PIPSharebelt);
  const { hideShareBeltShareButton } = theme.props;

  return (
    <Sharebelt horizontal={horizontal} itemId={itemId}>
      {!hideShareBeltShareButton && <ShareBeltShareButton email={email} />}
      <ShareBeltPrint />
    </Sharebelt>
  );
};

PIPSharebelt.displayName = 'PIPSharebelt';

PIPSharebelt.propTypes = {
  itemId: PropTypes.string.isRequired,
  horizontal: PropTypes.bool,
  email: PropTypes.bool,
};

PIPSharebelt.defaultProps = {
  horizontal: true,
  email: true,
};

PIPSharebelt.themeProps = {
  hideShareBeltShareButton: PropTypes.bool
};

PIPSharebelt.defaultThemeProps = {
  hideShareBeltShareButton: false
};

PIPSharebelt.dataModel = extend({}, Sharebelt);
